import { useTranslation } from "react-i18next";
import { Plus } from "@phosphor-icons/react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  SidebarIconButton,
} from "@hulahoop/ui";
import { SHELL_CREATE_ACTIONS, startShellCreate } from "./shellCreate";

const MENU_ORDER = ["beneficiary", "investor", "investment"] as const;

export function ShellQuickCreate() {
  const { t } = useTranslation();
  const actions = MENU_ORDER.map((kind) =>
    SHELL_CREATE_ACTIONS.find((action) => action.kind === kind),
  ).filter((action) => action !== undefined);
  return (
    <DropdownMenu>
      <SidebarIconButton
        variant="elevated"
        aria-label={t("shell.create")}
        tooltip={t("shell.create")}
        render={<DropdownMenuTrigger />}
        nativeButton
      >
        <Plus />
      </SidebarIconButton>
      <DropdownMenuContent align="start" className="w-56">
        {actions.map(({ kind, label, icon: Icon }) => (
          <DropdownMenuItem
            key={kind}
            className="font-medium"
            onClick={() => startShellCreate(kind)}
          >
            <Icon /> {t(label)}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
